module.exports = __webpack_public_path__ + "static/media/SourceSansPro-SemiBoldItalic.40000185.ttf";